import { Component, OnInit, ElementRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CategoryInspirationResource } from 'app/models/CategoryInspirationResource';
import { FormBuilder, Validators } from '@angular/forms';
import { UtilsService } from 'app/services/utils.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'vbn-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnInit {

  selected_language: string;
  category: CategoryInspirationResource;
  errorMessage: any;
  saveErrors: boolean = false;
  iconError: boolean = false;
  categoryRid: any;
  addressParams: any;
  dateNow: Date;

  constructor(
    private fb: FormBuilder,
    private service: UtilsService,
    private element: ElementRef,
    private _notificationService: NotificationsService,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
      this.selected_language = "ro";
      this.category = new CategoryInspirationResource();
      this.dateNow = new Date();
  }

  ngOnInit() {
    if(this.router.url != '/add-category') {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.addressParams = JSON.parse(atob(params['json']));
        this.categoryRid = this.addressParams.categoryRid;
      });
      this.getCategoryByRid(this.categoryRid);
    }
  }

  validationForm = this.fb.group({
    titleRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    titleEn: [''],
    titleFr: [''],
    titleDe: [''],
    descriptionRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    descriptionEn: [''],
    descriptionFr: [''],
    descriptionDe: [''],
  })

  changeListenerIcon($event): void {
    console.log("FFEFFF: ", $event)
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#iconInput');
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          console.log("eddddddddddddddd", image);
          this.category.iconString = e.target.result;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }

  changeListenerMainImage($event): void {
    console.log("FFEFFF: ", $event)
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#documentInput');
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          console.log("eddddddddddddddd", image);
          this.category.imageString = e.target.result;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }

  edit() {
    this.saveErrors = true;
    // this.iconError = false;
    if (!this.validationForm.valid) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      // if(!this.category.rid) {
      //   if(!this.category.iconString) {
      //     this.iconError = true;
      //   }
      // } else {
      //   if(this.category.iconString) {
      //     this.iconError = true;
      //   }
      // }
      return;
    }
    // if(this.category.rid) {
    //   if(!this.category.icon && !this.category.iconString) {
    //     this.iconError = true;
    //     return;
    //   }
    // } else {
    //   if(!this.category.iconString) {
    //     this.iconError = true;
    //     return;
    //   }
    // }
    this.service.add('/admin/newsCategory/editCategory', this.category)
      .subscribe(
        response => {
          this.category = response;
          if(this.categoryRid) {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('Category successfully edited!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          } else {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('Category successfully created!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          }
          this.router.navigate(['/categories-list']);
        },
        error => this.errorMessage = <any>error);
  }

  getCategoryByRid(rid) {
    this.service.get('/admin/newsCategory/getCategory/' + rid)
      .subscribe(
        response => {
          this.category = response;
        },
        error => this.errorMessage = <any>error);
  }

}
